import { supabase } from "./supabaseClient";

/**
 * Create a new room in Supabase
 * @param {string} roomName - Name of the room
 * @param {Array} players - List of players
 * @param {string} quizId - ID of the quiz
 * @returns {Object} - Contains data (room object) or error
 */
export async function createRoom(room) {
	try {
		const { name, players, quiz_id } = room;
		const { data, error } = await supabase
			.from("rooms")
			.insert([{ name, players, quiz_id }])
			.select();

		if (error) throw error;

		return { data: data[0], error: null };
	} catch (err) {
		console.error("Error creating room:", err);
		return { data: null, error: err };
	}
}

/**
 * Fetch a room by its ID from Supabase
 * @param {string} roomId - ID of the room to fetch
 * @returns {Object} - Contains data (room object) or error
 */
export async function fetchRoomById(roomId) {
	try {
		const { data, error } = await supabase
			.from("rooms")
			.select("*")
			.eq("id", roomId)
			.single(); // Fetch a single room by ID

		if (error) throw error;

		return { data, error: null };
	} catch (err) {
		console.error("Error fetching room:", err);
		return { data: null, error: err };
	}
}

/**
 * Update an existing room in Supabase
 * @param {string} roomId - ID of the room to update
 * @param {Object} updates - Object containing the fields to update
 * @returns {Object} - Contains data (updated room) or error
 */
export async function updateRoom(roomId, updates) {
	try {
		console.log("Updating room with ID:", roomId);
		console.log("Updates:", updates);
		const { data, error } = await supabase
			.from("rooms")
			.update(updates)
			.eq("id", roomId)
			.select();

		if (error) throw error;

		return { data: data[0], error: null };
	} catch (err) {
		console.error("Error updating room:", err);
		return { data: null, error: err };
	}
}
